import { ICoordinates, IModalSettings, IPickUpPoint, IWebSettings } from '@model';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IListingState } from '../../components';

import { initialState } from './initial';

export const deliveryModalSlice = createSlice({
  name: 'deliveryModal',
  initialState: { ...initialState },
  reducers: {
    open: (state) => {
      state.isOpen = true;
    },
    close: (state) => {
      state.isOpen = false;
    },
    setPickUpPoint: (state, action: PayloadAction<IPickUpPoint | null>) => {
      state.selectedPickUpPoint = action.payload ? { ...action.payload } : null;
    },
    setModalSettings: (state, action: PayloadAction<IModalSettings | null>) => {
      state.modalSettings = action.payload ? { ...action.payload } : null;
    },
    setWebSettings: (state, action: PayloadAction<IWebSettings[]>) => {
      state.webSettings = [...action.payload];
    },
    setInitialFilter: (state, action: PayloadAction<number | null>) => {
      state.initialFilter = action.payload;
    },
    setPreviousPups: (state) => {
      state.previousData.pupsFilter = state.filter;
    },
    setPreviousMap: (state) => {
      state.previousData.mapListingState = state.mapListingState;
    },
    setFilter: (state, action: PayloadAction<number[]>) => {
      state.filter = [...action.payload];
    },
    setMapListingState: (state, action: PayloadAction<IListingState | null>) => {
      state.mapListingState = action.payload ? { ...action.payload } : null;
    },
    setUserLocation: (state, action: PayloadAction<ICoordinates>) => {
      state.userLocation = { ...action.payload };
    },
    filterPickUpPoints: (state, action: PayloadAction<IPickUpPoint[]>) => {
      state.pickUpPoints = [...action.payload];
    },
    incrementShouldFetchData: (state) => {
      state.shouldFetchData++;
    },
    setPickupPointsAreLoading: (state, action: PayloadAction<boolean>) => {
      state.pickupPointsAreLoading = action.payload;
    },
  },
  selectors: {
    getState: (state) => state,
    getFetchDataSelector: (state) => ({
      shouldUpdate: state.shouldFetchData,
      mapState: {
        zoom: state.mapListingState?.zoom,
        center: state.mapListingState?.center,
        corner: state.mapListingState?.mapBounds?.southWest,
      },
      filter: state.filter,
      userLocation: state.userLocation,
    }),
    getPickUpPointsSelector: ({ filter, pickUpPoints }) =>
      pickUpPoints.filter((point) => filter.some((filterVal) => point.deliveryTypeId === filterVal)),
  },
});

export const {
  open,
  close,
  setPickUpPoint,
  setModalSettings,
  setWebSettings,
  setInitialFilter,
  setMapListingState,
  setFilter,
  setUserLocation,
  setPreviousPups,
  setPreviousMap,
  filterPickUpPoints,
  incrementShouldFetchData,
  setPickupPointsAreLoading,
} = deliveryModalSlice.actions;
export const { getState, getFetchDataSelector, getPickUpPointsSelector } = deliveryModalSlice.selectors;
export const deliveryModalReducer = deliveryModalSlice.reducer;
